import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=6f381ea8&scoped=true"
import script from "./layouts.vue?vue&type=script&lang=js"
export * from "./layouts.vue?vue&type=script&lang=js"
import style0 from "./layouts.vue?vue&type=style&index=0&id=6f381ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f381ea8",
  null
  
)

export default component.exports